module.exports = process.env.NODE_ENV === 'production' ? require('./build/mocks') : require('./build');

//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/airbnb-prop-types/index.js
// module id = 41
// module chunks = 168707334958949